import { render, staticRenderFns } from "./NotaReturn.vue?vue&type=template&id=8c9edb4a"
import script from "./NotaReturn.vue?vue&type=script&lang=js"
export * from "./NotaReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports